import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import history from "../routes/helper/history";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useRef} from "react";

export const Search = () => {
    const query = useRef('')

    return (
        <div className="search">
         
            <InputGroup className="mx-3">
                <FormControl
                    aria-label="Search"
                    aria-describedby="search-input"
                    type={"search"}
                    name={"query"}
                    placeholder={"Filtre sua pesquisa "}
                    onChange={(event) => {
                        query.current = event.target.value
                    }}
                />
                <InputGroup.Text id="search-input" onClick={() => history.push(`?q=${query.current}`)}>
                    <FontAwesomeIcon icon={["fa", "search"]}/>
                </InputGroup.Text>
            </InputGroup>
        </div>
    )
}

